export enum ContactType {
    CONTACT_US = "CONTACT_US",
    PRE_REG = "PRE_REG",
    RECRUITMENT = "RECRUITMENT"
}
